import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import consts from '../../constant';

const getHeaders = () => ({
    headers: {
        Authorization: `Bearer ${window.localStorage.getItem("Jetix")}`,
    },
});

export const fetchWithdraws = createAsyncThunk(
    'withdraw/fetchWithdraws',
    async (params, { rejectWithValue }) => {
        try {
            const queryParams = new URLSearchParams(params).toString();
            const response = await axios.get(`${consts.BackendUrl}/withdraw/admin/withdraws?${queryParams}`, getHeaders());
            return response.data;
        } catch (err) {
            return rejectWithValue(err.response?.data || err.message);
        }
    }
);

export const updateWithdrawStatus = createAsyncThunk(
    'withdraw/updateWithdrawStatus',
    async ({ id, data }, { rejectWithValue }) => {
        try {
            const response = await axios.put(`${consts.BackendUrl}/withdraw/admin/withdraw/${id}`, data, getHeaders());
            return response.data;
        } catch (err) {
            return rejectWithValue(err.response?.data || err.message);
        }
    }
);

const withdrawSlice = createSlice({
    name: 'withdraw',
    initialState: {
        withdraws: [],
        total: 0,
        loading: false,
        error: null,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchWithdraws.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchWithdraws.fulfilled, (state, action) => {
                state.loading = false;
                state.withdraws = action.payload.result.docs || [];
                state.total = action.payload.result.totalDocs || 0;
            })
            .addCase(fetchWithdraws.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })
            .addCase(updateWithdrawStatus.pending, (state) => {
                state.loading = true;
            })
            .addCase(updateWithdrawStatus.fulfilled, (state) => {
                state.loading = false;
            })
            .addCase(updateWithdrawStatus.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            });
    },
});

export default withdrawSlice.reducer;
